export const queryType = {
  EVENT_SIMPLE: 'EVENT_SIMPLE',
  EVENT_POSTPROCESS: 'EVENT_POSTPROCESS',
  EVENT_JOIN: 'EVENT_JOIN',
  FUNNEL: 'FUNNEL',
  RETENTION: 'RETENTION',
};

export const sortingOrder = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

export const sortingOrderBtnText = {
  ASCENDING: 'asc ↑',
  DESCENDING: 'desc ↓',
};

export const sortingTypes = {
  NAME: 'name',
  SUM: 'dataSum',
};

export const sortingTypeBtnText = {
  NAME: 'name',
  SUM: 'sum',
};

export const sortingOptions = {
  DEPEND: 'DEPENDENT',
  INDEPEND: 'INDEPENDENT',
};

// дефолтная группа для графиков
export const DEFAULT_GROUP = 'default group';

export const DATES = [
  'YEAR',
  'MONTH',
  'WEEK',
  'DAY',
  'HOUR',
  'MINUTE',
  'SECOND',
  'DAILY_COHORT',
  'WEEKLY_COHORT',
  'MONTHLY_COHORT',
  'TIME',
  'DATE',
];

export const COHORTS = {
  DAILY_COHORT: 'DAILY_COHORT',
  WEEKLY_COHORT: 'WEEKLY_COHORT',
  MONTHLY_COHORT: 'MONTHLY_COHORT',
};

export const requestDelay = 500;

export const DEFAULT_DATA = 'Date is not available';

export const CANCEL_REQUEST = 'Cancel request';

export const CANCEL_REQUEST_MESSAGE = 'The request was cancelled by user';

export const FETCH_ERROR = 'Fetch Error';
